import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {Service} from "../service";

// Все данные
const users = 'users'

// Пользователи
const createUser = 'create_user'
const updateUser = 'update_user'
const deleteUser = 'delete_user'

// Проекты
const createProject = 'create_project'
const updateProject = 'update_project'
const deleteProject = 'delete_project'

// Все данные
export const useGetUsers = () => useQuery({
    queryKey: [users],
    queryFn: () => Service.getUsers()
})

// Пользователи
export const useCreateUser = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationKey: [createUser],
        mutationFn: (user) => Service.createUser(user),
        onSettled: async () => await queryClient.invalidateQueries([users])
    })
}

export const useUpdateUser = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationKey: [updateUser],
        mutationFn: (user) => Service.updateUser(user),
        onSettled: async () => await queryClient.invalidateQueries([users])
    })
}

export const useDeleteUser = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationKey: [deleteUser],
        mutationFn: (user) => Service.deleteUser(user),
        onSettled: async () => await queryClient.invalidateQueries([users])
    })
}


// Проекты
export const useCreateProject = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationKey: [createProject],
        mutationFn: (project) => Service.createProject(project),
        onSettled: async () => await queryClient.invalidateQueries([users])
    })
}

export const useUpdateProject = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationKey: [updateProject],
        mutationFn: (project) => Service.updateProject(project),
        onSettled: async () => await queryClient.invalidateQueries([users])
    })
}

export const useDeleteProject = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationKey: [deleteProject],
        mutationFn: (project) => Service.deleteProject(project),
        onSettled: async () => await queryClient.invalidateQueries([users])
    })
}